import axios from "axios";
import { URLS } from "@/constants/constants";
import { getUserToken } from "@/firebase";

const api = axios.create({
  baseURL: URLS.BASE_URL_PROD,
  headers: {
    "Content-Type": "application/json",
    "access-control-allow-origin": "*", // Allow CORS
  },
});

api.interceptors.request.use(
  async (config) => {
    config.headers["token"] = await getUserToken(); // Set the token header
    // config.headers['token'] = localStorage.getItem('token');
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default api;
